<template>
  <v-system-bar color="grey-darken-3 justify-start">
    <v-btn
      variant="text"
      size="small"
      class="text-capitalize font-weight-light"
      :disabled="editActionsDisabled"
    >
      Επεξεργασία

      <v-menu activator="parent">
        <v-list>
          <v-list-item
            min-height="24"
            title="Προκαθορισμένο Κείμενο"
            @click="predefinedTextsDialog = true"
          />
        </v-list>
      </v-menu>
    </v-btn>

    <v-btn
      variant="text"
      size="small"
      class="text-capitalize font-weight-light"
      :disabled="editActionsDisabled"
    >
      Ρυθμίσεις
      <v-menu activator="parent">
        <v-list>
          <v-list-item
            min-height="24"
            title="Αντικατάσταση Λέξεων"
            @click="wordReplaceDialog = true"
          />
        </v-list>
      </v-menu>
    </v-btn>
  </v-system-bar>

  <PredefinedTextsDialog v-model="predefinedTextsDialog" />
  <WordReplaceDialog 
    v-model="wordReplaceDialog" 
  />
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import PredefinedTextsDialog from './PredefinedTextsDialog.vue'
import WordReplaceDialog from './WordReplaceDialog.vue'

const predefinedTextsDialog = ref(false)
const wordReplaceDialog = ref(false)
const route = useRoute()

const editActionsDisabled = computed(
  () =>
    !route.path.includes('/task/approval') &&
    !route.path.includes('/task/merging') &&
    !route.path.includes('/task/transcription')
)
</script> 